var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 93,
    viewBox: "0 0 78 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2285_16915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.3969 52.4009H58.814V27.758C58.814 17.0131 49.9249 8.25378 38.9832 8.25378C28.0415 8.25378 19.1694 17.0131 19.1694 27.758V52.4009H11.6035V27.758C11.6035 12.9088 23.8854 0.8125 39.0002 0.8125C54.115 0.8125 66.3969 12.9088 66.3969 27.758V52.4009Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78 89.6907C78 91.2925 76.6768 92.5772 75.0652 92.5772H2.93475C1.32318 92.5772 0 91.2758 0 89.6907V43.5915C0 41.9898 1.32318 40.7051 2.93475 40.7051H75.0652C76.6938 40.7051 78 42.0065 78 43.5915V89.6907Z",
    fill: "#F2CB30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.9988 89.6912V61.4443C54.2324 81.2155 19.9823 88.6401 0.558594 91.3763C1.08447 92.0937 1.94963 92.5776 2.93354 92.5776H75.064C76.6756 92.5776 77.9988 91.2762 77.9988 89.6912Z",
    fill: "#EAB531"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.4472 58.8245C45.4472 55.3207 42.5634 52.4844 39.001 52.4844C35.4385 52.4844 32.5547 55.3207 32.5547 58.8245C32.5547 60.91 33.5895 62.762 35.1671 63.9133L33.1145 78.2452H44.8874L42.8348 63.9133C44.4124 62.762 45.4472 60.9267 45.4472 58.8245Z",
    fill: "#58595A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.45898 46.1775V56.1047C2.73041 51.8836 4.78304 42.7238 17.6926 42.7238H5.98748C4.03663 42.7071 2.45898 44.2754 2.45898 46.1775Z",
    fill: "#F7DB5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.1133 78.2622C33.1133 78.2622 41.8497 75.8262 42.8336 63.9302L44.8862 78.2622H33.1133Z",
    fill: "#3E3D40"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2285_16915"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 78,
    height: 91.7647,
    fill: "white",
    transform: "translate(0 0.8125)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.5edf21e6.svg";
export { ForwardRef as ReactComponent };